import { FIREBASE_CONFIG } from '$lib/environment'
import { initializeApp } from 'firebase/app'
import { browserLocalPersistence, connectAuthEmulator, getAuth, initializeAuth } from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectStorageEmulator, getStorage } from 'firebase/storage'

const isE2E = window.Playwright

const app = initializeApp(FIREBASE_CONFIG)
const storage = getStorage(app)
const auth = isE2E ? initializeAuth(app, { persistence: browserLocalPersistence }) : getAuth(app)
const db = getFirestore(app)

if (isE2E) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099')

  connectStorageEmulator(storage, '127.0.0.1', 9199)
  storage.maxUploadRetryTime = 100
  storage.maxOperationRetryTime = 100

  connectFirestoreEmulator(db, '127.0.0.1', 8080)
}

export { app, storage, auth, db }
